import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // Corrected import
import 'react-toastify/dist/ReactToastify.css';
import { sendEmail } from '../services/emailService';

function CallbackPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [serviceName, setServiceName] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        service: '',
    });

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const service = searchParams.get('serviceName');
        if (service) {
            setServiceName(service);
            setFormData(prev => ({ ...prev, service: service }));
        }
    }, [location.search]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const result = await sendEmail(formData);
            console.log("EmailJS Response:", result); // Keep for debugging

            if (result.status >= 200 && result.status < 300) {
                toast.success('Callback request submitted successfully!');
                 setTimeout(() => {
                    navigate(-1);
                }, 500); // Add delay

            } else {
                toast.error('Failed to send callback request. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            toast.error('An error occurred while submitting the form.');
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg">
                <div className="text-center">
                    <h2 className="text-3xl font-extrabold text-gray-900">
                        Request a Callback
                    </h2>
                    {serviceName && (
                        <p className="mt-2 text-sm text-gray-600">
                            For: {serviceName}
                        </p>
                    )}
                </div>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="rounded-md shadow-sm">
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name</label>
                        <input id="name" name="name" type="text" required
                            className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                            placeholder="Your Name" value={formData.name} onChange={handleChange} />
                    </div>

                    <div className="rounded-md shadow-sm">
                        <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number</label>
                        <input id="phone" name="phone" type="tel" required
                            className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 focus:z-10 sm:text-sm"
                            placeholder="Your Phone Number" value={formData.phone} onChange={handleChange} />
                    </div>

                    <div className="rounded-md shadow-sm">
                        <label htmlFor="service" className="block text-sm font-medium text-gray-700">Service</label>
                        <select id="service" name="service" required
                            className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            value={formData.service} onChange={handleChange}>
                            <option value="" disabled>Select a Service</option>
                            <option value="Savings Accounts">Savings Accounts</option>
                            <option value="Current Accounts">Current Accounts</option>
                            <option value="Minor Accounts">Minor Accounts</option>
                            <option value="Micro-ATM">Micro-ATM</option>
                            <option value="AEPS">AEPS</option>
                            <option value="Gold Loans">Gold Loans</option>
                            <option value="Merchant Services">Merchant Services</option>
                            <option value="Personal Loans">Personal Loans</option>
                            <option value="Business Loans">Business Loans</option>
                            <option value="Fino Domestic Money Transfer">Fino Domestic Money Transfer</option>
                            <option value="Fino International Money Transfer">Fino International Money Transfer</option>
                            <option value="Life Insurance">Life Insurance</option>
                            <option value="Health Insurance">Health Insurance</option>
                            <option value="General Insurance">General Insurance</option>
                            <option value="Fixed Deposits">Fixed Deposits</option>
                            <option value="Credit Card Bill Payments">Credit Card Bill Payments</option>
                            <option value="FASTags">FASTags</option>
                            <option value="Atal Pension Yojana">Atal Pension Yojana</option>
                        </select>
                    </div>

                    <div>
                        <button type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                            Submit Request
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default CallbackPage;